import { gql } from 'apollo-angular';


import { CART_FRAGMENT, ERROR_RESULT_FRAGMENT, ORDER_ADDRESS_FRAGMENT } from '../../../common/graphql/fragments.graphql';

export const GET_ORDER_SHIPPING_DATA = gql`
    query GetOrderShippingData {
        activeOrder {
            id
            customer {
                id
                firstName
                lastName
                emailAddress
                customFields {
                    isCompany
                    companyName
                }
            }
            shippingAddress {
                ...OrderAddress
            }
        }
    }
    ${ORDER_ADDRESS_FRAGMENT}
`;

export const SET_SHIPPING_ADDRESS = gql`
    mutation SetShippingAddress($input: CreateAddressInput!) {
        setOrderShippingAddress(input: $input) {
            ...Cart
            ...on Order {
                shippingAddress {
                    ...OrderAddress
                }
            }
            ...ErrorResult
        }
    }
    ${CART_FRAGMENT}
    ${ORDER_ADDRESS_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;

export const GET_ELIGIBLE_SHIPPING_METHODS = gql`
    query GetEligibleShippingMethods {
        eligibleShippingMethods {
            id
            name
            code
            description
            price
            priceWithTax
            metadata
        }
    }
`;

export const SET_SHIPPING_METHOD = gql`
    mutation SetShippingMethod($id: [ID!]!) {
        setOrderShippingMethod(shippingMethodId: $id) {
            ...Cart
            ...ErrorResult
        }
    }
    ${CART_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;

export const SET_CUSTOMER_FOR_ORDER = gql`
    mutation SetCustomerForOrder($input: CreateCustomerInput!) {
        setCustomerForOrder(input: $input) {
            ...on Order {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                }
            }
            ...ErrorResult
        }
    }
    ${ERROR_RESULT_FRAGMENT}
`;

export const TRANSITION_TO_ARRANGING_PAYMENT = gql`
    mutation TransitionToArrangingPayment {
        transitionOrderToState(state: "ArrangingPayment") {
            ...Cart
            ...ErrorResult
        }
    }
    ${CART_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;

export const SET_ORDER_SHIPPING_ADDRESS = gql`
    mutation SetOrderShippingAddress($input: CreateAddressInput!) {
        setOrderShippingAddress(input: $input) {
            __typename
            ... on Order {
                id
                code
                shippingAddress {
                    fullName
                    streetLine1
                    streetLine2
                    city
                    postalCode
                    countryCode
                    phoneNumber
                }
            }
            ... on ErrorResult {
                errorCode
                message
            }
        }
    }
`;

export const GET_DPD_SHOPS = gql`
  query GetDpdParcelShops($args: DpdParcelShopsArgs!) {
    dpdParcelShops(args: $args) {
      parcelShopId
      company
      street
      houseNumber
      postalCode
      city
      latitude
      longitude
    }
  }
`;

export const SET_DPD_SHOP = gql`
  mutation SetDpdParcelShop($input: UpdateOrderInput!) {
    setOrderCustomFields(input: $input) {
        ... on Order {
            id
            customFields {
                dpdParcelShopId
            }
            }
            ... on ErrorResult {
            errorCode
            message
            }
        }
    }
`;

export const SET_ADDRESS_TYPE_FOR_ORDER = gql`
    mutation SetAddressTypeForOrder($input: UpdateOrderInput!) {
        setOrderCustomFields(input: $input) {
            ... on Order {
                ...Cart
            }
            ... on ErrorResult {
                errorCode
                message
            }
        }
    }
    ${CART_FRAGMENT}
`;

export const GET_DHL_SHOPS = gql`
    query GetDhlParcelShops($args: DhlServicePointsArgs!) {
        dhlServicePoints(args: $args) {
            retailID
            name
            street
            postalCode
            city
            countryCode
            latitude
            longitude
            distance
        }
    }
`;

export const SET_DHL_SHOP = gql`
  mutation SetDhlParcelShop($input: UpdateOrderInput!) {
    setOrderCustomFields(input: $input) {
        ... on Order {
            id
            customFields {
                dhlShopData
            }
            }
            ... on ErrorResult {
            errorCode
            message
            }
        }
    }
`;
